/**
 * This file is a part of Amblique's projects.
 *
 * Copyright © Amblique - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import 'amb/directives';

import { compilerService } from 'amb/services/compiler.service';

import { actionDirective } from './action.directive';
import { countdownDirective } from './countdown.directive';
import { newsletterDirective } from './newsletter.directive';
import { recommendationDirective } from './recommendation.directive';
import { scrollSpyDirective } from './scroll-spy.directive';
import { splitScreenDirective } from './split-screen.directive';
import { stampDirective } from './stamp.directive';
import { vehicleGradesCarouselDirective } from './vehicle-grades-carousel.directive';

compilerService.register('ambAction', actionDirective);
compilerService.register('ambCountdown', countdownDirective);
compilerService.register('ambNewsletter', newsletterDirective);
compilerService.register('ambRecommendation', recommendationDirective);
compilerService.register('ambScrollSpy', scrollSpyDirective);
compilerService.register('ambSplitScreen', splitScreenDirective);
compilerService.register('ambStamp', stampDirective);
compilerService.register('ambVehicleGradesCarousel', vehicleGradesCarouselDirective);
